export default __webpack_public_path__ + "static/media/logo.ce19be39.webp";